"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class DataHydrator {
    constructor(platformDataHydrator) {
        this.platformDataHydrator = platformDataHydrator;
    }
    createDefaultDataUserProperty() {
        const data_user = {
            timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        };
        return data_user;
    }
    createDefaultDataWebProperty() {
        const data_web = {
            url: window.location.href,
            domain: window.location.hostname,
            path: window.location.pathname.replace(/^\/|\/$/g, ''),
            user_agent: window.navigator.userAgent,
            referrer: window.document.referrer,
            browser_device: "",
        };
        if (window.location.search !== '') {
            data_web.url_parameters = Object.fromEntries(new URLSearchParams(window.location.search));
        }
        return data_web;
    }
    createDefaultDataAppProperty() {
        const data_app = {
            screen: `${window.screen.width}x${window.screen.height}`,
        };
        return data_app;
    }
}
exports.default = DataHydrator;
